module.exports = __webpack_public_path__ + "img/column_202601.691cd7bf.png";